import { withMetadata } from '../min/metadata'

import _findPhoneNumbers from '../es6/findPhoneNumbers'

export function findPhoneNumbers() {
	return withMetadata(_findPhoneNumbers, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/findPhoneNumbers.js
// module id = +03h
// module chunks = 0 1